import { render, staticRenderFns } from "./DocumentsSignModal.vue?vue&type=template&id=b4ad3998&scoped=true&"
import script from "./DocumentsSignModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsSignModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsSignModal.vue?vue&type=style&index=0&id=b4ad3998&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ad3998",
  null
  
)

export default component.exports